import {
    UPLOAD_DOCUMENT,
    GET_UPLOADING_DOCUMENT,
    GET_UPLOADING_DOCUMENT_SUCCESS,
    GET_UPLOADING_DOCUMENT_FAILED,
    CLEAR_DATA,
    CREAT_BATCH_SCAN,
    CREAT_BATCH_SCAN_FAILED,
    CREAT_BATCH_SCAN_SUCCESS,
    DELETE_DOCUMENT_FROM_SESSION,
    DELETE_DOCUMENT_FROM_SESSION_FAILED,
    DELETE_DOCUMENT_FROM_SESSION_SUCCESS,
    EDIT_DOCUMENT_IN_SESSION,
    EDIT_DOCUMENT_IN_SESSION_FAILED,
    EDIT_DOCUMENT_IN_SESSION_SUCCESS,
    EXECUTE_BATCH_SCAN,
    EXECUTE_BATCH_SCAN_FAILED,
    EXECUTE_BATCH_SCAN_SUCCESS,
    GET_ALL_TEMPLATES,
    GET_ALL_TEMPLATES_FAILED,
    GET_ALL_TEMPLATES_SUCCESS,
    OPEN_DOCUMENT_EDITOR,
    SELECT_TEMPLATE,
    SUBSCRIBE_UPLOADING_DOCUMENT,
    UPLOAD_DOCUMENT_FAILED,
    UPLOAD_DOCUMENT_SUCCESS,
    VIEW_PROCESSING_DOCUMENT
} from './constants';

import {cloneDeep} from 'lodash';

const INIT_STATE = {
    step: 0,
    templates: [],
    selectedTemplate: null,
    documents: [],
    session: {
        valid_items: [],
        duplicated_items: [],
        existed_items: []
    },
    isQueueLoading: false,
    uploadQueue: [],
    results: [],
    documentEditor: null,
    processingDocumentIndex: -1,
    loadingInStep: true,
    loadingBetweenStep: false,
    error: null
};

const scanReducers = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_DATA:
            return cloneDeep(INIT_STATE)
        case GET_ALL_TEMPLATES:
            return {...state, loadingInStep: true};
        case GET_ALL_TEMPLATES_SUCCESS:
            return {
                ...state,
                templates: action.payload.templates,
                others: action.payload.others,
                loadingInStep: false,
                error: null
            };
        case GET_ALL_TEMPLATES_FAILED:
            return {...state, error: action.payload, loadingInStep: false};
        case SELECT_TEMPLATE:
            return {...state, selectedTemplate: action.payload, documents: []};
        case CREAT_BATCH_SCAN:
            return {...state, loadingBetweenStep: true};
        case CREAT_BATCH_SCAN_SUCCESS:
            const {channel, batchId} = action.payload
            return {...state, channel, batchId, loadingBetweenStep: false, error: null, step: 1};
        case CREAT_BATCH_SCAN_FAILED:
            return {...state, error: action.payload, loadingBetweenStep: false};
        case UPLOAD_DOCUMENT:
            const document = {
                file: action.payload.file,
                mapId: action.payload.mapId,
                loading: true,
                progress: action.payload.progress
            };
            return {...state, documents: [...state.documents, document]};
        case SUBSCRIBE_UPLOADING_DOCUMENT:
            let documents = cloneDeep(state.documents)
            documents.forEach(item => {
                if (item.mapId === action.payload.mapId) {
                    item.progress = action.payload.progress
                }
                return item
            })
            return {...state, documents: documents, error: null};
        case UPLOAD_DOCUMENT_SUCCESS:
            documents = cloneDeep(state.documents)
            documents.forEach(item => {
                if (item.mapId === action.payload.mapId) {
                    item['image'] = action.payload.image
                    item['loading'] = false
                    item['status'] = action.payload.status
                }
                return item
            })
            return {...state, documents: documents, session: action.payload.session, error: null};
        case UPLOAD_DOCUMENT_FAILED:
            documents = cloneDeep(state.documents)
            documents = documents.filter(item => item.mapId !== action.payload.mapId)
            return {...state, documents: documents, error: action.payload.error};
        case GET_UPLOADING_DOCUMENT:
            documents = cloneDeep(state.documents)
            documents.forEach(item => {
                if (item.mapId === action.payload.mapId) {
                    item['loadingDetail'] = true
                }
                return item
            })
            return {...state, documents: documents, error: null};
        case GET_UPLOADING_DOCUMENT_SUCCESS:
            documents = cloneDeep(state.documents)
            documents.forEach(item => {
                if (item.mapId === action.payload.resource_id) {
                    item['loadingDetail'] = false
                    item['document'] = action.payload
                }
                return item
            })
            return {...state, documents: documents, error: null};
        case GET_UPLOADING_DOCUMENT_FAILED:
            documents = cloneDeep(state.documents)
            documents.forEach(item => {
                if (item.mapId === action.payload.mapId) {
                    item['loadingDetail'] = false
                }
                return item
            })
            return {...state, documents: documents, error: action.payload.error};
        case OPEN_DOCUMENT_EDITOR:
            return {...state, documentEditor: action.payload};
        case EDIT_DOCUMENT_IN_SESSION:
            return {...state, loadingInStep: true};
        case EDIT_DOCUMENT_IN_SESSION_SUCCESS:
            documents = cloneDeep(state.documents)
            documents.forEach(item => {
                if (item.mapId === action.payload.mapId) {
                    item['loading'] = false
                    item['status'] = action.payload.document.status
                    item['document'] = action.payload.document
                }
                return item
            })
            return {...state, session: action.payload.session, documents: documents, loadingInStep: false, error: null};
        case EDIT_DOCUMENT_IN_SESSION_FAILED:
            return {...state, error: action.payload, loadingInStep: false};
        case DELETE_DOCUMENT_FROM_SESSION:
            return {...state, loadingInStep: true};
        case DELETE_DOCUMENT_FROM_SESSION_SUCCESS:
            documents = state.documents.filter(item => item.mapId !== action.payload.mapId)
            return {...state, session: action.payload.session, documents: documents, loadingInStep: false, error: null};
        case DELETE_DOCUMENT_FROM_SESSION_FAILED:
            return {...state, error: action.payload, loadingInStep: false};
        case EXECUTE_BATCH_SCAN:
            return {...state, results: [], loadingBetweenStep: true};
        case EXECUTE_BATCH_SCAN_SUCCESS:
            return {...state, results: action.payload, loadingBetweenStep: false, error: null, step: 2};
        case EXECUTE_BATCH_SCAN_FAILED:
            return {...state, error: action.payload, loadingBetweenStep: false};
        case VIEW_PROCESSING_DOCUMENT:
            return {...state, processingDocumentIndex: action.payload};
        default:
            return {...state};
    }
};

export default scanReducers;
